import { render, staticRenderFns } from "./PayeeInfoInputFile.vue?vue&type=template&id=6e0d55d0&scoped=true&"
import script from "./PayeeInfoInputFile.vue?vue&type=script&lang=ts&"
export * from "./PayeeInfoInputFile.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeInfoInputFile.vue?vue&type=style&index=0&id=6e0d55d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0d55d0",
  null
  
)

export default component.exports